export default __webpack_public_path__ + "static/media/nick.341d6901.png";